import { Toggler } from './Toggler'

export default Toggler
